import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

export const chat: ThemeUICSSObject = {
  /* PREPEND HERE */
  height: 'calc(100vh - 300px)',
  width: '100%',
  border: '1px solid',
  borderColor: 'palette.border.section',

  '.chat_controller': {
    display: 'flex',
    flexDirection: 'column',
    gap: '3',
  },

  '.autoscrollContainer': {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: 3,
    p: 3,
  },

  '.history__message': {
    borderRadius: '2px',
    p: 3,
    width: '80%',
    wordWrap: 'break-word',
    whiteSpace: 'pre-wrap',

    '&.user': {
      alignSelf: 'end',
      backgroundColor: '#90ee902b',
    },

    '&.system': {
      alignSelf: 'start',
      backgroundColor: '#5701f52b',
    },

    '&.warning': {
      alignSelf: 'start',
      backgroundColor: '#ffff0024',
      width: '100%',
    },

    '&.error': {
      alignSelf: 'start',
      backgroundColor: '#fd84212b',
      width: '100%',
    },

    '&.information': {
      alignSelf: 'start',
      backgroundColor: '#2222cc2b',
      width: '100%',
    },

    '&.multipleChoice': {
      p: 0,
    },

    '.multipleChoiceMessage:not(.customRenderer)': {
      background: '#0178f52b',
      td: { textAlign: 'center' },
      th: { backgroundColor: '#14597bab' },
      table: { borderBottom: '1px solid' },
      'button.multipleChoice__option': {
        width: '-webkit-fill-available',
        backgroundColor: '#14597bab',
      },
      '.taskInfoDiv': {
        display: 'flex',
        justifyContent: 'space-evenly',
      },
    },

    '.multipleChoiceMessage.customRenderer': {
      display: 'flex',
      flexDirection: 'column',
      gap: 3,

      '& > p': {
        background: '#0178f52b',
        p: 3,
      },

      '.selection__keyHandler': {
        m: 0,
        padding: 3,
        border: '1px solid',
        borderColor: 'palette.border.article',
        borderRadius: 'panel',
      },
    },
  },

  '.help__container': {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },

  '.functionHelp': {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,

    '.functionHelp__description, .functionHelp__usage': {
      pl: 5,
    },
    '.history__message': {
      wordWrap: 'break-word',
      overflow: 'hidden',
      whiteSpace: 'break-spaces',
    },
  },
};
